import Vue from "vue";
import VueApollo from "vue-apollo";
import { ApolloClient } from "apollo-client";
import { createUploadLink } from "apollo-upload-client";
import { InMemoryCache } from "apollo-cache-inmemory";

Vue.use(VueApollo);

// HTTP connection to the API
const uploadLink = createUploadLink({
  uri: process.env.VUE_APP_GRAPHQL_URI,
  credentials: "include"
});

// Create the apollo client
const apolloClient = new ApolloClient({
  link: uploadLink,
  cache: new InMemoryCache(),
  defaultOptions: { query: { fetchPolicy: "no-cache" } }
});

export default new VueApollo({
  defaultClient: apolloClient
});

export { apolloClient };
